import { Power } from 'lucide-react';
import { signOut } from 'next-auth/react';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';

export default function LogoutButton({ callbackUrl }: { callbackUrl?: string }) {
    const router = useRouter();

    const handleLogout = async () => {
        await signOut({ redirect: false });
        router.replace(callbackUrl || '/auth/signin');
        toast.success('You are now logged out.');
    };

    return (
        <button
            onClick={handleLogout}
            className="h-fit cursor-pointer rounded-md border-1 border-error hover:bg-error-content bg-error p-2 flex items-center justify-center before:text-[0.6875rem] tooltip tooltip-left"
            data-tip="Log out"
        >
            <Power size={16} />
        </button>
    );
}
